import Image from "./src/main.vue";
export default Image;
